import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from './Tooltip';
import './tooltipStyle.scss';
import { connect } from 'react-redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import {
  REDUCER_NAME,
  fectchInforCompanyScore,
  fetchInfoCompanyScoreValue,
} from './reducer';
import Loading from '../../../common/loading/Loading';
import Const from './Const';
const _format = require('string-format');
_format.extend(String.prototype, {});

class TooltipScoreValue extends Component {
  componentDidMount() {
    const { fetchInfoCompanyScoreValue, organCode, id } = this.props;
    fetchInfoCompanyScoreValue(organCode, id);
  }

  renderCheckedValue = (isCheck, keyI18n) => {
    const className = isCheck ? 'tooltip-body-checked' : 'tooltip-body-remove';
    return (
      <span className={className}>
        <span>{keyI18n}</span>
      </span>
    );
  };

  renderTooltipHeader = (childProps = []) => {
    const {
      score,
      colorLeft,
      colorRight,
      listSearch,
      scoring,
      ticker,
    } = this.props;

    const totalCategories = childProps.length;
    const numCurrentCategories = childProps.filter(
      item => item.rateValue !== '0.00',
    ).length;

    const inforCompany = listSearch.find(function(element) {
      return score.organCode === element.organCode;
    });
    let styleObj = {
      backgroundImage: _format(
        'linear-gradient(93deg, {0}, {1})',
        colorLeft || Const.colorGradient.colorLeft,
        colorRight || Const.colorGradient.colorRight,
      ),
    };
    return (
      <div className="tooltip-header" style={styleObj}>
        <div className="tooltip-header-row">
          <span className="tooltip-ticker-name-score">{ticker}</span>
          <span className="tooltip-header-score"> {scoring}</span>
          <span className="tooltip-ticker-name-score">{`${
            childProps.length ? childProps[0].scoreType : 'VGM'
          } Score (${numCurrentCategories}/${totalCategories})`}</span>
        </div>
        <div className="tooltip-header-row">
          <span className="tooltip-ticker-fullName">
            {inforCompany ? inforCompany.organShortName : '--'}
          </span>
        </div>
      </div>
    );
  };

  renderContentTooltip = (childProps = []) => {
    const listData = childProps.map(item => {
      return {
        value: item.rateValue !== '0.00',
        name: item.rateIndicatorName,
      };
    });

    const FIXED_INDEX = Math.round(childProps.length / 2);

    return (
      <div className="tooltip-body">
        <div className="tooltip-body-row">
          <div className="tooltip-body-row-col w-50">
            {listData.slice(0, FIXED_INDEX).map((item, index) => {
              return (
                <div key={index}>
                  {this.renderCheckedValue(item.value, item.name)}
                </div>
              );
            })}
          </div>
          <div className="tooltip-body-row-col w-50">
            {listData.slice(FIXED_INDEX).map((item, index) => {
              return (
                <div key={index}>
                  {this.renderCheckedValue(item.value, item.name)}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  getColorOFfSCore = score => {
    switch (score) {
      case 'B':
        return 'scoreValue-span bg-box-b';
      case 'C':
        return 'scoreValue-span bg-box-c';
      case 'D':
        return 'scoreValue-span bg-box-d';
      case 'E':
        return 'scoreValue-span bg-box-e';
      case 'F':
        return 'scoreValue-span bg-box-f';
      default:
        return 'scoreValue-span bg-box-a';
    }
  };
  formatText = text => {
    return text || '--';
  };

  render() {
    const {
      parent,
      isHovering,
      parentContent,
      isLoading,
      valueType,
      scoreValue = [],
      tooltipHeight,
    } = this.props;
    const dataBelongToValueType = scoreValue.filter(
      data => data.scoreType.toUpperCase() === valueType.toUpperCase(),
    );
    // filter data

    if (!isHovering) return null;
    return (
      <Tooltip
        parent={parent}
        parentContent={parentContent}
        active={isHovering}
        position={'leftBottom'}
        arrow={null}
        heightTooltip={tooltipHeight}
        widthTooltip={320}
      >
        <div
          className={`tooltip-ticker-hover`}
          style={{ minHeight: tooltipHeight }}
          ref={el => (this.hoverRef = el)}
        >
          {isLoading ? (
            <Loading />
          ) : (
            <>
              {this.renderTooltipHeader(dataBelongToValueType)}
              {this.renderContentTooltip(dataBelongToValueType)}
            </>
          )}
        </div>
      </Tooltip>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    listSearch: state[COMMON_REDUCER_NAME].listOrganizationSearch,
    score: state[REDUCER_NAME][props.id].score,
    scoreValue: state[REDUCER_NAME][props.id].scoreValue,
    isLoading: state[REDUCER_NAME][props.id].isLoading,
    i18n: state.i18n,
  };
};

TooltipScoreValue.propTypes = {
  fectchInforCompanyScore: PropTypes.func.isRequired,
  tooltipHeight: PropTypes.number,
};

TooltipScoreValue.defaultProps = {
  tooltipHeight: 152,
};

const mapDispatchToProps = {
  fectchInforCompanyScore,
  fetchInfoCompanyScoreValue,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TooltipScoreValue);
